import axios from 'axios';
import { from } from 'rxjs';

export const validateAddress = (address) => {
  const arrayAddress = Array.isArray(address) ? address : [address];
  const addingOtherThings = arrayAddress.map((addy) => {
    const countryCode = addy.countryCode && addy.countryCode.trim() !== '' ? addy.countryCode : 'US';
    return {
      ...addy,
      countryCode,
      validationResult: 'Unverified',
      validationMessage: '',
      orderToken: '',
      bypassSanitization: false,
      bypassSanitizationIntl: false,
    };
  });
  const postAddress = axios.post('/address/validate', addingOtherThings).then((response) => {
    return response.data;
  });

  return from(postAddress);
};
// oxlint-disable-next-line jsdoc/require-jsdoc
/**
 @deprecated This endpoint updateSalesOrderShipTo acts on salesorders so should not be used
 */
export const updateSalesOrderShipTo = (salesOrderId, address) => {
  const postAddress = axios.post(`/SalesOrder/${salesOrderId}/SetShipTo`, address);

  return from(postAddress);
};

export const createEmptyFulfillmentPlanForSalesOrderIds = ({ salesOrderId, fulfillmentPlanId }) => {
  return axios
    .post('/fulfillmentplan', {
      salesOrderId,
      fulfillmentPlanId,
    })
    .then((response) => {
      return response.data;
    });
};
